// Temporary workaround. Resolve ASAP. Do not add more ignores like this.
// eslint-disable-next-line eslint-comments/no-restricted-disable
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  ItemAlertStatus,
  ItemStatus,
  transformAlertToItemStatus,
} from '@marketplace-web/item-page/item-status-data'

import { ProductItemModel } from '../types/product-item'

export const getProductItemStatus = (
  item: ProductItemModel,
  showSensitive = false,
): ItemStatus | null => {
  const {
    isDraft,
    isReserved,
    isHidden,
    isClosed,
    canPushUp,
    areStatsVisible,
    itemAlertType,
    itemAlert,
    itemClosingAction,
    isProcessing,
    isPromoted,
  } = item

  if (isProcessing) return 'processing'
  if (
    itemAlert?.itemAlertType &&
    showSensitive &&
    itemAlert.itemAlertType !== ItemAlertStatus.EligibleForAuthenticity &&
    itemAlert.itemAlertType !== ItemAlertStatus.VerifiedOnlineAuthenticity
  ) {
    return transformAlertToItemStatus(itemAlert.itemAlertType)
  }
  if (itemAlertType && showSensitive) return transformAlertToItemStatus(itemAlertType)
  if (isDraft) return 'draft'
  if (isClosed && itemClosingAction) {
    return itemClosingAction
  }
  if (isReserved) return 'reserved'
  if (isHidden) return 'hidden'
  if (!areStatsVisible) return null
  if (!showSensitive) return null
  if (canPushUp) return null
  if (isPromoted) return 'bumped'

  return null
}
